<template>
  <div>
    <vs-popup :title="$t('ModifyCountry')" :active.sync="showModal">
      <form>
        <div>
          <vs-input
            class="inputx mb-3"
            v-model="CountryForModify.name"
            :label="$t('Name')"
            name="Name"
            v-validate="{  required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{
            errors.first("Name")
          }}</span>
        </div>
        <div>
          <vs-input
            class="inputx mb-3"
            v-model="CountryForModify.priority"
            :label="$t('Priority')"
            name="Priority"
            v-validate="{required: 'true'}"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Priority')"
            >{{ errors.first("Priority") }}</span
          >
        </div>

        <vs-button
          type="filled"
          class="float-right my-4"
          @click.prevent="submitForm"
          :disabled="!CountryForModify.priority || !CountryForModify.name"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    Name: {
      required: "لطفا نام کشور را وارد نمایید.",
    },

    Priority: {
      required: "لطفا اولویت را وارد نمایید.",
    },
  }
};
Validator.localize("fa", dict);
export default {
  name: "",
  props: {
    show: { default: false },
    CountryForModify: {}
  },
  components: {},
  data() {
    return {
      model: {},
      disabled: false
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  mounted(){
  },
  methods: {
    ...mapActions({
      modifyCountry: "country/modifyCountry"
    }),
    submitForm() {
      this.$validator.validateAll().then(r => {
        if (r) {
          this.modifyCountry(this.CountryForModify).then(() => {
            this.disabled = false;
            this.$emit("finish");
            this.model = {};
          });
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "خطا در ثبت مقادیر وارده شده",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    }
  }
};
</script>
